import { cleanFormat } from './clean-format.function';
import { removeDayFromFormat } from './remove-day-from-format.function';
import { removeMonthFromFormat } from './remove-month-from-format.function';
import { removeQuarterFromFormat } from './remove-quarter-from-format.function';
import { removeWeekFromFormat } from './remove-week-from-format.function';
import { removeYearFromFormat } from './remove-year-from-format.function';

/**
 * Removes all date-related parts (year, month, day, quarter, week) from a format string,
 * leaving only the time-related parts.
 */
export function removeDateFromFormat(format: string) {
  return cleanFormat(
    removeQuarterFromFormat(
      removeWeekFromFormat(
        removeDayFromFormat(removeMonthFromFormat(removeYearFromFormat(format))),
      ),
    ),
  );
}
